module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/facility-a5ab70ccfa83cd06daed7647ee320ade.webp";